declare interface INutNutConf {
  url: string;
}

const prod: INutNutConf = {
  url: 'https://api.nutnut.io'
}

const dev: INutNutConf = {
  url: 'http://localhost:8080'
}

export default process.env.REACT_APP_STAGE === 'production' ? prod : dev;


// WEBPACK FOOTER //
// ./src/conf.ts